export type RuleType = 'RESTRICT' | 'DATE_MOVE' | 'SMS';

export type SmsRecipient = 'candidate' | 'executor';
export type SmsEvent = 'ASSIGN_EXECUTOR' | 'STAGE_CHANGE' | 'CREATE_LEAD';

export interface RuleForm {
  ruleType: RuleType;
  // RESTRICT / DATE_MOVE
  triggerColumn: string;
  targetColumn: string;
  requiredFields: string[];
  dateField: string;
  actual: boolean;
  // SMS
  smsName: string;
  smsEvent: SmsEvent;
  smsTemplateId: string;
  smsProviderId: string;
  smsRecipient: SmsRecipient;
  runOnce: boolean;
  groupIds: string[];
  excludeUserIds: string[];
}

export const EMPTY_RULE_FORM: RuleForm = {
  ruleType: 'RESTRICT',
  triggerColumn: '',
  targetColumn: '',
  requiredFields: [],
  dateField: '',
  actual: true,
  smsName: '',
  smsEvent: 'STAGE_CHANGE',
  smsTemplateId: '',
  smsProviderId: '',
  smsRecipient: 'candidate',
  runOnce: false,
  groupIds: [],
  excludeUserIds: [],
};

export const SMS_RECIPIENT_OPTIONS: { value: SmsRecipient; label: string }[] = [
  { value: 'candidate', label: 'Кандидат (tasks.phone)' },
  { value: 'executor',  label: 'Исполнитель (work_phone)' },
];

export const SMS_EVENT_OPTIONS: { value: SmsEvent; label: string }[] = [
  { value: 'ASSIGN_EXECUTOR', label: 'Назначение исполнителя' },
  { value: 'STAGE_CHANGE',    label: 'Переход на этап' },
  { value: 'CREATE_LEAD',     label: 'Создание лида' },
];

export const RULE_TYPE_OPTIONS: { value: RuleType; label: string; desc: string }[] = [
  { value: 'RESTRICT',  label: 'Ограничение',    desc: 'Запрещает перемещение без заполнения полей' },
  { value: 'DATE_MOVE', label: 'Перенос по дате', desc: 'Переносит в колонку при наступлении даты' },
  { value: 'SMS',       label: 'SMS уведомление', desc: 'Отправляет SMS при переходе в колонку' },
];

export const LEAD_FIELDS: { value: string; label: string }[] = [
  { value: 'title',       label: 'ФИО' },
  { value: 'phone',       label: 'Телефон' },
  { value: 'destination', label: 'Направление' },
  { value: 'sending',     label: 'Дата отправки' },
  { value: 'arrival',     label: 'Дата прибытия' },
  { value: 'city',        label: 'Город' },
  { value: 'age',         label: 'Возраст' },
  { value: 'note',        label: 'Примечание' },
];

export const DATE_LEAD_FIELDS: { value: string; label: string }[] = [
  { value: 'sending', label: 'Дата отправки' },
  { value: 'arrival', label: 'Дата прибытия' },
];
